import React, { useState, useEffect } from 'react';
import { popupOpenService } from '../../../services/popupOpenService';
import Modal from '../../Modal';
import { MODAL_SMALL_SIZE } from '../../helper';
import UpdateSeveralPropertiesSaveButton from './UpdateSeveralPropertiesSaveButton';
import UpdateSeveralPropertiesFormsList from './UpdateSeveralPropertiesFormsList';
import { useTranslation } from 'react-i18next';
import UpdateSeveralPropertiesListOfProperties from './UpdateSeveralPropertiesListOfProperties';
import { updateSeveralPropertiesService } from '../../../services/updateSeveralPropertiesService';
import { Button } from '@chapche/ui';

const UpdateSeveralPropertiesModalContent = ({propertyId, handleClose}) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title block__title-h3">{i18n.t('app.page.product.modal.updateProperties.title')}</h2>
            <div className="modal__list">
                <UpdateSeveralPropertiesFormsList propertyId={propertyId}/>
                <UpdateSeveralPropertiesListOfProperties />
            </div>
            <div className="modal__button-group property__button-group">
                <Button variant="outline" className="property__button" onClick={() => handleClose(null)}>
                    {i18n.t('app.page.product.modal.updateProperties.cancel')}
                </Button>
                <UpdateSeveralPropertiesSaveButton closeCallback={handleClose}/>
            </div>
        </>
    )
};

const UpdateSeveralPropertiesPopup = () => {
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const [propertyId, setPropertyId] = useState('');

    const changePopupState = (newValue) => {
        setPropertyId(newValue);
        setPopupIsOpen(true);
    };

    useEffect(() => {
        popupOpenService.registerPopup('apply-to', changePopupState);
        return () => popupOpenService.unRegisterPopup(changePopupState);
    }, []);

    const closePopup = () => {
        updateSeveralPropertiesService.deleteFormFromFormsList();
        updateSeveralPropertiesService.deletePropertyFromPropertiesList();
        setPopupIsOpen(false);
    };

    return (
        popupIsOpen ?
            <Modal handleCloseModal={closePopup} size={MODAL_SMALL_SIZE} 
                content={<UpdateSeveralPropertiesModalContent handleClose={closePopup} propertyId={propertyId}/>}/>
            :
            null
    );
};

export default UpdateSeveralPropertiesPopup;
